import { classNames } from "@/react/helpers/twMergeWithCN";
import type { DetailedProperties } from "@/react/types";

export interface CoverVideoProps {
  className?: string;
  cover: DetailedProperties["cover"];
  isPreviewing?: boolean;
  overrideVideoProperties?: {
    autoplay: boolean;
    muteVideo: boolean;
    loopVideo: boolean;
    shouldShowControls: boolean;
  };
  videoClassName?: string;
  videoProperties?: DetailedProperties["cover_video_properties"];
}

export const CoverVideo = ({
  className,
  videoClassName,
  cover,
  videoProperties,
  isPreviewing = false,
  overrideVideoProperties,
}: CoverVideoProps) => {
  const videoUrl = cover?.url;
  const thumbnailUrl = videoProperties?.custom_cover_image?.url;
  const shouldMuteVideo = isPreviewing ? true : videoProperties?.mute_video;
  const shouldAutoplay = isPreviewing ? false : videoProperties?.autoplay;
  const shouldLoopVideo = isPreviewing ? false : videoProperties?.loop_video;

  if (!videoUrl) {
    return null;
  }

  return (
    <div
      className={classNames(
        "grid place-items-center size-full md:w-[768px]",
        className,
      )}
    >
      <video
        className={classNames(
          "w-full z-0 col-start-1 row-start-1 border-solid object-cover",
          videoClassName,
        )}
        autoPlay={overrideVideoProperties?.autoplay ?? shouldAutoplay}
        muted={overrideVideoProperties?.muteVideo ?? shouldMuteVideo}
        loop={overrideVideoProperties?.loopVideo ?? shouldLoopVideo}
        poster={thumbnailUrl}
        controls={overrideVideoProperties?.shouldShowControls ?? true}
        preload="metadata"
        playsInline
        data-testid="paywall-cover-media"
      >
        <source src={videoUrl} />
      </video>
    </div>
  );
};
